import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'auth-not-found',
  standalone: true,
  template: `
    <div class="au-shell">
      <div class="au-card">
        <h1 class="au-card__title">404</h1>
        <p class="au-card__sub">{{ i18n.t('error.404') || 'Страница не найдена.' }}</p>
        <a class="au-button" [href]="'/ru/login'">{{ i18n.t('error.go_login') || 'На главную' }}</a>
      </div>
    </div>
  `,
})
export class NotFoundComponent implements OnInit {
  private route = inject(ActivatedRoute);
  protected i18n = inject(I18nService);

  async ngOnInit(): Promise<void> {
    const langParam = this.route.snapshot.paramMap.get('lang');
    await this.i18n.use(I18nService.normaliseFromUrl(langParam));
  }
}
